import Vue from 'vue'
import Vuex from 'vuex'
Vue.use(Vuex)

const state = {
     Login: {
         Auth_Login :   false,
         Username   :   '',
         Token      :   '',
         Level      :   ''
     },
  //   base_url       :   'http://localhost:3004/v4'
  
    base_url       :   '/v4'
 //base_url : 'https://slfis.edu.la/v4'

}
const mutations = {
    setLogin(state,b){
        state.Login.Auth_Login=b
        
        
    },
    setUsername(state,b){
        state.Login.Username=b
    }

}
const actions = {
    setLogin({ commit }){
        commit("setLogin",true)
       
    },
    setUsername({ commit,user }){
        commit("setUsername",user)
    }

}
const getters = {
    getAuth(){
        return state.Login.Auth_Login
    },
    getBaseUrl(){
        return state.base_url
    }
}

export default new Vuex.Store({
    state,
    mutations,
    actions,
    getters
})